import React from 'react';
import styles from '../../Recurring.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Scheduling</span>
            <h2>Schedule it. Forget it.</h2>
            <p>Set any rhythm your business runs on — weekly, monthly, quarterly, or a custom interval. Add a start date, an optional end date, and time-zone control so invoices land exactly when you intend.</p>
            <ul className={styles.fList}>
              {['Weekly, monthly, or custom cadence', 'Start and end dates', 'Time-zone control', 'Choose the preferred payment method'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 8 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Schedule</div>
              <span className={styles.invLab}>MONTHLY</span>
            </div>
            <div className={styles.invRow}><span>Repeats</span><span className={styles.mono}>Every 1st</span></div>
            <div className={styles.invRow}><span>Starts</span><span className={styles.mono}>May 1, 2026</span></div>
            <div className={styles.invRow}><span>Ends</span><span className={styles.mono}>No end date</span></div>
            <div className={styles.invRow}><span>Time zone</span><span className={styles.mono}>PT</span></div>
            <div className={styles.invPaynow}>Save schedule →</div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Full control</span>
            <h2>Pause without losing the invoice.</h2>
            <p>Need to skip a cycle or put a client on hold? Turn recurring off and back on whenever you like — your invoice and its history stay intact, so nothing has to be rebuilt.</p>
            <ul className={styles.fList}>
              {['Turn recurring on and off', 'Pause without deleting the invoice', 'Edit the amount or schedule any time', 'Full history kept for every cycle'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Recurring schedules</div>
              <span className={styles.invLab}>3 TOTAL</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Retainer — Acme</div><div className={styles.recMeta}>Monthly · next May 1</div></div>
              <span className={styles.recAmt}>$2,500</span>
              <span className={styles.recToggle} />
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Hosting — Bloom Co</div><div className={styles.recMeta}>Monthly · next Apr 28</div></div>
              <span className={styles.recAmt}>$49</span>
              <span className={styles.recToggle} />
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOff}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Coaching — J. Reyes</div><div className={styles.recMeta}>Paused</div></div>
              <span className={styles.recAmt}>$300</span>
              <span className={`${styles.recToggle} ${styles.recToggleOff}`} />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />At scale</span>
            <h2>Bill many clients at once.</h2>
            <p>Send the same recurring invoice to a whole list of recipients, and see every active and paused schedule in one place. Saved payment methods mean repeat clients are charged without lifting a finger.</p>
            <ul className={styles.fList}>
              {['Send automatically to multiple recipients', 'See every recurring schedule in one view', 'Saved payment methods for repeat clients', 'Automatic receipts every cycle'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>This cycle</div>
              <span className={styles.invLab}>AUTO-SENT</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>12 subscribers · Newsletter</div><div className={styles.recMeta}>Sent · Apr 1</div></div>
              <span className={styles.recAmt}>$108</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>4 retainers</div><div className={styles.recMeta}>Sent · Apr 1</div></div>
              <span className={styles.recAmt}>$9,200</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Studio memberships</div><div className={styles.recMeta}>Collecting</div></div>
              <span className={styles.recAmt}>$1,450</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
